var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('folders-list-links',{staticClass:"mt16",attrs:{"items":_vm.ports}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }